import { render, staticRenderFns } from "./insure_edit.vue?vue&type=template&id=628a17c1&scoped=true"
import script from "./insure_edit.vue?vue&type=script&lang=js"
export * from "./insure_edit.vue?vue&type=script&lang=js"
import style0 from "./insure_edit.vue?vue&type=style&index=0&id=628a17c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a17c1",
  null
  
)

export default component.exports